{ Jadelet, Modal, Observable } from @danielx/dui

Template := Jadelet.exec """
section.song-picker
  h2 🎵 Your Song Collection
  button.close(click=@close) X
  table
    thead
      tr
        th Title
        th Size (kb)
        th Last Updated
    tbody
      @items
"""

RowTemplate := Jadelet.exec """
tr(@click)
  td @title
  td @size
  td @updatedAt
"""

FolderRowTemplate := Jadelet.exec """
tr(@click)
  td(colspan=3) @title
"""

type AccountSongData =
  folder: boolean
  path: string
  relativePath: string
  title: string
  size: number
  updatedAt: Date

export AccountSongPicker := (player: Player) ->
  player.showAccountSongPicker ?= (data: AccountSongData[]) ->
    self.data data
    Modal.show self.element

  self :=
    close: -> Modal.hide()
    items: ->
      @data().map ({folder, path, relativePath, size, updatedAt}) ->
        if folder
          FolderRowTemplate
            title: relativePath
            click: ->
              player.displayLoadingModal()
              player.account().fs.list path
              .then player.showAccountSongPicker
        else
          RowTemplate
            title: relativePath
            updatedAt: updatedAt.toLocaleString()
            size: (size / 1024).toFixed(2)
            click: ->
              Modal.hide()

              player.loadFromAccountPath(path)
    data: Observable [] as AccountSongData[]
    element: null as! HTMLElement

  self.element = Template self

  return self

export default AccountSongPicker
